import Icon from "~/components/ui/Icon"
import { ImageWidget } from "~/types/widgets"
import ImageComponent from "~/components/ui/Image"
import { Fragment } from "react"

/**
 * @titleBy alt
 */
interface Image {
    /**
     * @title Imagem
     */
    image: ImageWidget
    /**
     * @title Largura
     */
    width: number
    /**
     * @title Altura
     */
    height: number
    /**
     * @title Texto alternativo
     */
    alt: string
    url?: string
}

/**
 * @title Segurança
 */
export interface Props {
    /**
     * @title Título
     */
    title: string
    /**
     * @title Imagens
     */
    images: Image[]
    /**
     * @title Itens por linha
     * @description Defina a quantidade de itens que ficará em cada linha
     * @default 3
     */
    itemsPerRow?: number
    /**
     * @title Aberto
     * @description Escolha se o componente deverá vir aberto por padrão
     */
    open?: boolean
    /**
     * @ignore
     */
    isMobile?: boolean
}

export default function Security(
    { title, images = [], itemsPerRow = 3, open: _open = false, isMobile }: Props,
) {
    if (isMobile) {
        return (
            <div className='w-full'>
                <div className='collapse rounded-none text-sm relative'>
                    <input type='checkbox' id={`input-${title}`} className='fixed hidden peer' />
                    <label
                        htmlFor={`input-${title}`}
                        className='group collapse-title font-bold text-salmon-light p-0 min-h-0 h-12 w-full flex justify-between items-center text-base'
                    >
                        <span>{title}</span>
                        <Icon
                            id='ChevronRight'
                            size={24}
                            strokeWidth={2}
                            className='peer-checked:group-[]:rotate-90 absolute right-3 top-1/2 -translate-y-1/2 transition-transform'
                        />
                    </label>
                    <div className='collapse-content !p-0'>
                        <div className='pt-2 pb-4 px-0 w-fit mx-auto'>
                            <ul
                                style={{
                                    gridTemplateColumns: `repeat(${
                                        Math.min(
                                            itemsPerRow,
                                            images.length,
                                        )
                                    }, minmax(0, 1fr))`,
                                }}
                                className='flex gap-1 justify-center items-center flex-wrap'
                            >
                                {images.map(({ alt, image, width, height, url }) => {
                                    const Component = url ? 'a' : Fragment
                                    const props = url ? { href: url } : {}

                                    return (
                                        <li key={url ?? image ?? alt} title={alt}>
                                            <Component {...props}>
                                                <ImageComponent
                                                    width={width}
                                                    height={height}
                                                    src={image}
                                                    alt={alt}
                                                    loading='lazy'
                                                />
                                            </Component>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='flex flex-col gap-4'>
            <p className='text-salmon-light font-bold'>{title}</p>
            <ul
                style={{
                    gridTemplateColumns: `repeat(${
                        Math.min(itemsPerRow, images.length)
                    }, minmax(0, 1fr))`,
                }}
                className='grid gap-1 justify-center items-center'
            >
                {images.map(({ alt, image, width, height, url }) => {
                    const Component = url ? 'a' : Fragment
                    const props = url ? { href: url } : {}

                    return (
                        <li key={url ?? image ?? alt} title={alt}>
                            <Component {...props}>
                                <ImageComponent
                                    width={width}
                                    height={height}
                                    src={image}
                                    alt={alt}
                                    loading='lazy'
                                />
                            </Component>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
